const msToMetersMap = {
  AMER: 63761.84,
  EMEA: 46165.13,
  APAC: 70934.89,
};

const msToMeters = (ms, region) => (!!region && !!ms ? ms * msToMetersMap[region] : 0);

export default msToMeters;
